<!-- 登录页foot -->
<template>
  <Layout class="yscFooterLayout wow fadeInUp">
    <Footer class="yscFooter">
      <Row>
        <Col span="16">
          <Col span="6">
            <h5 class="c_f_title">关于我们</h5>
            <ul class="c_f_links">
              <li><a href="/about" :clstag="yscClstags.index.footer_about">关于我们</a></li>
              <li><a href="/contact" :clstag="yscClstags.index.footer_contact">联系我们</a></li>
            </ul>
          </Col>
          <Col span="6">
            <h5 class="c_f_title">快速入口</h5>
            <ul class="c_f_links">
              <!-- <li><a href="//reg.jd.com/reg/company" :clstag="yscClstags.index.footer_reg">立即注册</a></li> -->
              <li><a href="/authc/forwardHome" :clstag="yscClstags.index.footer_use" v-if="userPin">使用产品</a></li>
              <li><a :href="urlByEnv.passwordHome" :clstag="yscClstags.index.footer_use" v-if="!userPin">使用产品</a></li>
            </ul>
          </Col>
          <Col span="6">
            <h5 class="c_f_title">帮助中心</h5>
            <ul class="c_f_links">
              <li><a href="/questions" :clstag="yscClstags.index.footer_questions">常见问题</a></li>
              <li><a href="/documents" :clstag="yscClstags.index.footer_documents">文档中心</a></li>
            </ul>
          </Col>
          <Col span="6">
            <h5 class="c_f_title">联系方式</h5>
            <p style="margin-bottom: 10px;">Email：Y@jd.com</p>
            <p>工作时间：9:00-18:00</p>
          </Col>
        </Col>
        <Col span="8" class="c_f_qrcode">
          <Col span="12">
            <img src="@/assets/images/qr2.jpg" alt="">
            <div class="c_f_qr_txt">关注诸葛智享了解更多资讯</div>
          </Col>
          <Col span="12">
            <img src="@/assets/images/qr3.jpg" alt="">
            <div class="c_f_qr_txt">诸葛用户交流群</div>
          </Col>
        </Col>
      </Row>
      <div class="c_f_copyright">
        Copyright © 2017-2018 JD.COM 京东版权所有 Power by <strong>Y事业部</strong>
      </div>
    </Footer>
  </Layout>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import ComUrl from '@/request/common'
import { urlByEnvFn } from '@/utils/utils.js'
import { YscClstags } from '@/utils/clstags'
import {WOW} from 'wowjs'
export default {
  // import引入的组件需要注入到对象中才能使用
  components: {},
  data () {
    // 这里存放数据
    return {
      userInfo: null,
      userPin: false,
      urlByEnv: {},
      // 埋点
      yscClstags: YscClstags
    }
  },
  methods: {
    getUserInfo () {
      ComUrl.queryUserInfo().then(res => {
        if (res.success) {
          this.userPin = true
        }
      })
    },
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted () {
    this.urlByEnv = urlByEnvFn()
    var wow = new WOW({
      live: false
    })
    wow.init()
    this.getUserInfo()
  }
}
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
@import "../../../../assets/muss/muss";
@import "../../../../assets/scss/yscLogin.scss";
.yscFooterLayout{
  background-color: #373b43;
  .yscFooter {
    width: 1200px;
    margin: 0 auto;
    background-color: transparent;
    color: #ffffff;
    padding: 40px 15px;
  }
  .c_f_title{
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 10px;
  }
  .c_f_links{
    li {
      margin-bottom: 10px;
    }
    a {
      display: inline-block;
      color: #ffffff;
    }
  }
  .c_f_qrcode{
    text-align: center;
    padding-left: 30px;
    border-left: 1px solid #4a4f5b; 
    img{
      width: 90px;
    }
  }
  .c_f_qr_txt{
    width: 100px;
    margin: 10px auto 0;
  }
  .c_f_copyright{
    text-align: center;
    padding-top: 25px;
    font-size: 12px;
    strong{
      color: #ef3333;
      padding: 0 10px;
      font-weight: normal;
    }
  }
}
</style>
